import { template } from '@belong/common';
import { Button, ButtonBase, Image, Text } from '@belong/ui';
import clsx from 'clsx';
import { HOUSE_PAGE_STRINGS } from '../../house-page.strings';
import type { Section } from '../../utils';
import css from './home-tour.module.css';

const SECTION_NAME_MAX_LENGTH = 23;

type HomeTourProps = {
  mediaSectionNames: Section[];
  numberOfPhotos: number;
  onAllPhotosClick: () => void;
  onSectionClick: (sectionName: string) => void;
};

export function HomeTour({
  mediaSectionNames,
  numberOfPhotos,
  onSectionClick,
  onAllPhotosClick,
}: HomeTourProps): JSX.Element {
  return (
    <div className="pl-2xs">
      <div className="mb-xl gap-x-lg gap-y-xl grid grid-cols-2 items-start md:grid-cols-4">
        {mediaSectionNames.map(({ type, media, id }, idx) => (
          <div className={clsx('w-full', css.section)} key={idx}>
            <ButtonBase className="w-full" onClick={() => onSectionClick(id)}>
              <div
                className={clsx(
                  'mb-xs border-navy duration-hover w-full overflow-hidden rounded border border-solid transition-all',
                  css.image,
                )}
              >
                {media[0]?.url && (
                  <Image src={media[0].url} alt="" className="object-cover" />
                )}
              </div>
              <Text fontWeight="semibold">
                {(type || '').length > SECTION_NAME_MAX_LENGTH
                  ? `${type?.slice(0, SECTION_NAME_MAX_LENGTH)}...`
                  : type}
              </Text>
            </ButtonBase>
          </div>
        ))}
      </div>
      <div className="flex justify-end">
        <Button onClick={onAllPhotosClick} variant="text">
          {numberOfPhotos === 1
            ? HOUSE_PAGE_STRINGS['tour.seePhoto']
            : template(HOUSE_PAGE_STRINGS['tour.seePhotosWithNumber'], {
                number: numberOfPhotos,
              })}
        </Button>
      </div>
    </div>
  );
}
